import ClusterScanDetailDialog from "./clusterScanDetailDialog.container";

export default ClusterScanDetailDialog;
